const CLIENT_BFF_PREFIX = '/api/internal/bff';
const CLIENT_START_API_PREFIX = '/v2/start';
const CLIENT_CONFIG_PREFIX = '/api/internal/config';
const CLIENT_BIFROST_PREFIX = '/api/internal/bifrost';
const CLIENT_GEO_API_PREFIX = '/api/internal/geoapi';
const CLIENT_STRING_STORE_PREFIX = '/api/internal/string-store';
const CLIENT_CW_PREFIX = '/api/internal/continue-watching';
const CLIENT_WATCHLIST_PREFIX = '/api/internal/watchlist';
const CLIENT_FRESHSTART_API_PREFIX = '/v2/freshstart';
const CLIENT_FINGERPRINT_PREFIX = '/api/internal/fingerprint';
const CLIENT_SUBSCRIPTION_ORIGIN = '/api/internal/bff/gringotts';
const HF_DOMAIN_PART = 'hf-apix.hotstar.com';

enum CustomHeader {
  X_COUNTRY_CODE = 'X-Country-Code',
  X_HS_DEVICE_ID = 'x-hs-device-id',
  X_HS_USERTOKEN = 'x-hs-usertoken',
  X_HS_PLATFORM = 'X-HS-Platform',
  X_USER_AGENT = 'X-User-Agent',
  X_HS_HID = 'X-Hs-hid',
  X_HS_PID = 'X-Hs-Pid',
  X_HS_ACCEPT_LANGUAGE = 'X-HS-Accept-language',
  X_CLIENT_PARTNER_DATA = 'x-client-partner-data',
  HOTSTARAUTH = 'hotstarauth',
  X_HS_CLIENT = 'X-HS-Client',
  X_HS_REQUEST_ID = 'x-hs-request-id',
  X_QA_TESTING = 'x-qa-testing',
  X_HS_UPDATEDUSERTOKEN = 'x-hs-updatedusertoken',
  X_HS_FORCE_REFRESH = 'X-HS-ForceRefresh',
  X_HS_CLIENT_TARGETING = 'X-HS-Client-Targeting',
  X_HS_SET_PROXY_STATE = 'x-hs-setproxystate',
  UPDATE_HS_ID = 'update_hs_id',
  X_HS_SET_PROXY_STATE_UD = 'x-hs-setproxystate-ud',
  X_HS_CACHE_CONTROL = 'x-hs-cache-control',
  X_HS_CONSUMED_TIME_MS = 'x-hs-consumed-time-ms',
  X_HS_FREETIMER = 'x-hs-freetimer',
  X_HS_SET_CLIENT_CACHE_STATE = 'x-hs-setclient-cache-state',
  X_HS_IS_RETRY = 'x-hs-is-retry',
  X_HS_RETRY_COUNT = 'x-hs-retry-count',
  X_HS_APP = 'x-hs-app',
  X_HS_USER_INFO = 'x-hs-user-info',
  X_HS_UPDATED_USER_INFO = 'x-hs-updated-user-info',
  X_INTERNAL_JC_DEEP_LINK = 'x-internal-jc-deeplink'
}

export {
  CLIENT_BFF_PREFIX,
  CLIENT_START_API_PREFIX,
  CLIENT_FRESHSTART_API_PREFIX,
  CLIENT_CONFIG_PREFIX,
  CLIENT_BIFROST_PREFIX,
  CLIENT_GEO_API_PREFIX,
  CLIENT_STRING_STORE_PREFIX,
  CLIENT_CW_PREFIX,
  CLIENT_WATCHLIST_PREFIX,
  CLIENT_FINGERPRINT_PREFIX,
  CLIENT_SUBSCRIPTION_ORIGIN,
  CustomHeader,
  HF_DOMAIN_PART
};
